var map = {
	"./environment.abancadev": 6149,
	"./environment.abancadev.ts": 6149,
	"./environment.dev": 1652,
	"./environment.dev.ts": 1652,
	"./environment.local": 6497,
	"./environment.local.ts": 6497,
	"./environment.stage": 7645,
	"./environment.stage.ts": 7645,
	"./environment.ts": 2340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3309;